/**
 * =============================================================================
 * JKL DRAWER BRIDGE
 * =============================================================================
 *
 * This script bridges the Shadow DOM boundary for links in the drawer header.
 * Since JavaScript cannot access elements inside the Shadow DOM from the
 * light DOM, we forward clicks from shadow links to hidden bridge links
 * outside the Shadow DOM.
 *
 * Bridges:
 * - Wishlist link (for Swym integration)
 * - Account login link (for drawer opening via aria-controls)
 *
 * =============================================================================
 */

(function() {
  'use strict';

  const initDrawerBridges = () => {
    const drawer = document.querySelector('#sidebar-menu');
    if (!drawer) return;

    // Get the shadow root
    const shadowRoot = drawer.shadowRoot;
    if (!shadowRoot) return;

    // =========================================================================
    // WISHLIST BRIDGE
    // =========================================================================
    const shadowWishlistLink = shadowRoot.querySelector('.swym-wishlist');
    const bridgeWishlistLink = document.querySelector('#swym-wishlist-bridge');

    if (shadowWishlistLink && bridgeWishlistLink) {
      // Forward clicks from shadow wishlist to bridge wishlist
      shadowWishlistLink.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        bridgeWishlistLink.click();
      });
    }

    // =========================================================================
    // ACCOUNT LOGIN BRIDGE
    // =========================================================================
    const shadowAccountLink = shadowRoot.querySelector('.drawer__action-link[aria-controls="account"]');
    const bridgeAccountLink = document.querySelector('#account-login-bridge');

    if (shadowAccountLink && bridgeAccountLink) {
      // Forward clicks from shadow account link to bridge account link
      shadowAccountLink.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        bridgeAccountLink.click();
      });
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerBridges);
  } else {
    initDrawerBridges();
  }
})();
